import type { BaseResponse } from "@marketplace/shared/types";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";

import { AuthService } from "../../services/auth-service";

type UsePostLogoutMutationParams = {
  options?: UseMutationOptions<BaseResponse<string>, unknown, void>;
};

export const usePostLogoutMutation = ({
  options
}: UsePostLogoutMutationParams = {}) => {
  return useMutation({
    mutationFn: async () => {
      return await AuthService.logout();
    },
    ...options
  });
};
